import React from 'react';
import axios, { CancelTokenSource } from 'axios';
import { connect } from 'react-redux';

import ConfirmationModal from '../../shared/modal/ConfirmationModal';
import Icon from '../icon/Icon';

import { IApplicationState } from '../../../store/applicationState';
import { addFavoriteAttachment, removeFavoriteAttachment } from '../../../store/group/groupActions';

interface IStateProps {
    viewerIsDi: boolean;
}

interface IOwnProps {
    id: string;
    groupId: string;
    messageId: string
    isFavorite: boolean;
    isDisconnected?: boolean;
}

interface IDispatchProps {
    addFavoriteAttachment: typeof addFavoriteAttachment;
    removeFavoriteAttachment: typeof removeFavoriteAttachment;
}

type Props = IStateProps & IOwnProps & IDispatchProps;

interface IOwnState {
    isFavorite: boolean;
    isRemoving: boolean;
    isSpinning: boolean;
}

class AttachmentFavorite extends React.Component<Props, IOwnState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isFavorite: this.props.isFavorite,
            isRemoving: false,
            isSpinning: false
        };
    }

    public render() {
        const isFavorite = this.props.isFavorite || (this.props.isDisconnected && this.state.isFavorite);

        return this.props.viewerIsDi &&
            <React.Fragment>
                {isFavorite ?
                    <span id="removefavorite" key="removefavorite" onClick={this.toggleRemovingFavoriteAttachment} onMouseUp={this.stopTrackDownloadPropagation}><Icon key="removefavoriteicon" name="star-filled" /></span>
                    :
                    <span id="addfavorite" key="addfavorite" onClick={this.addFavoriteDocument(this.props.id)} onMouseUp={this.stopTrackDownloadPropagation}><Icon key="addfavoriteicon" name="star" /></span>
                }
                <ConfirmationModal show={this.state.isRemoving} onAccept={this.removeFavoriteAttachment(this.props.id)} buttonsClickable={!this.state.isSpinning} onReject={this.toggleRemovingFavoriteAttachment} acceptText="Fjern">
                    <h3>Fjern fremhævet dokument</h3>
                    <p>Ønsker du at stoppe med at fremhæve dette dokument?</p>
                </ConfirmationModal>
            </React.Fragment>
    }

    private addFavoriteDocument = (id: string) => (e: React.MouseEvent<HTMLSpanElement>) => {
        e.preventDefault();

        this.props.addFavoriteAttachment(this.props.groupId, this.props.messageId, id)

        if (this.props.isDisconnected) {
            this.setState({
                isFavorite: true
            });
        }
    }

    private toggleRemovingFavoriteAttachment = (e: React.FormEvent<HTMLElement> | React.MouseEvent<HTMLElement> | KeyboardEvent) => {
        e.preventDefault();

        this.setState(prevState => ({
            isRemoving: !prevState.isRemoving
        }));
    }

    private removeFavoriteAttachment = (id: string) => () => {
        this.setState({
            isSpinning: true
        });

        this.props.removeFavoriteAttachment(this.props.groupId, this.props.messageId, id)

        if (this.props.isDisconnected) {
            this.setState({
                isFavorite: false,
            });
        }

        this.setState({
            isRemoving: false,
            isSpinning: false
        });
    }

    private stopTrackDownloadPropagation = (e: React.MouseEvent<HTMLSpanElement>) => {
        e.preventDefault();
        e.stopPropagation();
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => ({
    viewerIsDi: state.oidc.user && state.oidc.user.profile && state.oidc.user.profile.role === 'DI'
});

const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
    addFavoriteAttachment: (groupId: string, messageId: string, attachmentId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(addFavoriteAttachment(groupId, messageId, attachmentId, cancelToken)),
    removeFavoriteAttachment: (groupId: string, messageId: string, attachmentId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(removeFavoriteAttachment(groupId, messageId, attachmentId, cancelToken))
});

const container = connect(mapStateToProps, mapDispatchToProps)(AttachmentFavorite);

export default container;